import { ButtonV2, FormModeV2 } from "../FormControlsV2";
import { useTranslation } from "react-i18next";

type FormActionsProps = {
  mode: FormModeV2;
  onCancel?: () => void;
};

export function FormActions({ mode, onCancel }: FormActionsProps) {
  const { t } = useTranslation();
  if (mode === "readonly") return null;
  return (
    <div className="ov2-property-form__actions">
      {onCancel && (
        <ButtonV2 variant="secondary" onClick={onCancel}>
          {t("formsV2.cancel")}
        </ButtonV2>
      )}
      <ButtonV2 type="submit">{t(mode === "edit" ? "formsV2.saveChanges" : "formsV2.save")}</ButtonV2>
    </div>
  );
}
